import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";

const RewardAuditLogTable = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [Status, setStatus] = useState("default");

  const [logs] = useState([
    {
      id: 1,
      admin: "Superadmin",
      email: "superadmin@system.com",
      role: "Super Admin",
      action: "Updated Reward",
      details: "Changed discount value from 10% to 20%",
      entity: "Follow Us & Enjoy",
      date: "03-Sep-2025 10:30 AM",
    },
    {
      id: 2,
      admin: "John Admin",
      email: "john.admin@system.com",
      role: "Admin",
      action: "Deleted Reward",
      details: "Removed Festive Cashback offer",
      entity: "Follow Us & Enjoy",
      date: "02-Sep-2025 05:15 PM",
    },
    {
      id: 3,
      admin: "Superadmin",
      email: "superadmin@system.com",
      role: "Super Admin",
      action: "Updated Category",
      details: "Changed category from Books to Stationary",
      entity: "Follow Us & Enjoy",
      date: "01-Sep-2025 11:50 AM",
    },
  ]);

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search..."
          />
          <div className=" form">
            <Select
              fullWidth
              value={Status}
              onChange={(e: SelectChangeEvent) => setStatus(e.target.value)}
            >
              <MenuItem disabled value="default">
                Select Role
              </MenuItem>
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Admin">Admin</MenuItem>
              <MenuItem value="Super">Super Admin</MenuItem>
            </Select>
          </div>
        </div>
      </div>

      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Admin/User</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Details</TableCell>
              <TableCell>Entity</TableCell>
              <TableCell>Date & Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log) => (
              <TableRow hover key={log.id}>
                {/* Admin Info */}
                <TableCell>
                  <div className="user_block">
                    <figure>
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="Images"
                      />
                    </figure>
                    <p>
                      <b>{log.admin}</b>
                      <span>{log.email}</span>
                    </p>
                  </div>
                </TableCell>

                {/* Role */}
                <TableCell>{log.role}</TableCell>

                {/* Action */}
                <TableCell>{log.action}</TableCell>

                {/* Details */}
                <TableCell>{log.details}</TableCell>

                {/* Entity */}
                <TableCell>
                  Reward:{" "}
                  <Box
                    component="a"
                    className="click_action"
                    onClick={() => navigate("/manage-boost-plans/detail")}
                  >
                    <b>{log.entity}</b>
                  </Box>
                </TableCell>

                {/* Date */}
                <TableCell>{log.date}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default RewardAuditLogTable;
